module.exports = __webpack_public_path__ + "img/sobreBanner.9b0c49af.png";